export default Object.freeze({
    ADD_INTERNAL: 'add_internal',
    ADD_EXTERNAL: 'add_external',
    EDIT: 'edit'
  });
  